import { Country } from "./models/countries.models";
import axiosInstance from "./axios";
import { EcomodClass } from "./models/ecomodClass.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchEcomodClasses = async (
  bearerToken
): Promise<EcomodClass[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Report/reports/ecomodclass`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch ecomod classes:", error);
    throw error;
  }
};
